import { render, staticRenderFns } from "./ScanCode.vue?vue&type=template&id=1fc584e0&scoped=true&"
import script from "./ScanCode.vue?vue&type=script&lang=js&"
export * from "./ScanCode.vue?vue&type=script&lang=js&"
import style0 from "../../less/scan.less?vue&type=style&index=0&id=1fc584e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc584e0",
  null
  
)

export default component.exports